import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
interface Contact {
  name: string;
  contact: string;
  email: string;
  mobile:number;
  address: string;
  message: string;
  subject: string;
  isactive: boolean;

}

const ContactView = () => {
  const { contactid } = useParams<{ contactid: string }>(); 
  const [contact, setContact] = useState<Contact | undefined>(undefined);
  const [loading, setLoading] = useState(true);

  const fetchContactById = async (id: string) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}contact/getcontact/${id}`;
      console.log('Fetching from URL:', url);  
      const response = await axios.get<Contact>(url); 
      console.log('API Response:', response.data); 
      setContact(response.data); 
    } catch (error) {
      console.error("Error fetching contact:", error);  
    } finally {
      setLoading(false); 
    }
  };

  useEffect(() => {
    console.log('Contact ID:', contactid);  
    if (contactid) {  
      fetchContactById(contactid);
    } else {
      console.error('No contact ID found in the route');
      setLoading(false);  
    }
  }, [contactid]);  

  if (loading) {
    return <div>Loading...</div>;  
  }

  if (!contact) {
    return <div>No contact found</div>;  
  }

  return (
    <div className="contact-view-container">
      <h2 className="text-center my-4">Contact Details</h2>
      <div className="card shadow-sm p-4">
        <div className="row mb-3">
          <div className="col-sm-4 font-weight-bold">Name:</div>
          <div className="col-sm-8">{contact.name || 'N/A'}</div>
        </div>
        <div className="row mb-3">
          <div className="col-sm-4 font-weight-bold">Mobile:</div>
          <div className="col-sm-8">{contact.mobile || 'N/A'}</div>
        </div>
        <div className="row mb-3">
          <div className="col-sm-4 font-weight-bold">Email:</div>
          <div className="col-sm-8">{contact.email || 'N/A'}</div>
        </div>
        <div className="row mb-3">
          <div className="col-sm-4 font-weight-bold">Address:</div>
          <div className="col-sm-8">{contact.address || 'N/A'}</div>
        </div>
        <div className="row mb-3">
          <div className="col-sm-4 font-weight-bold">Message:</div>
          <div className="col-sm-8">{contact.message || 'N/A'}</div>
        </div>
        <div className="row mb-3">
          <div className="col-sm-4 font-weight-bold">Subject:</div>
          <div className="col-sm-8">{contact.subject || 'N/A'}</div>
        </div>
        {/*<div className="row mb-3">
          <div className="col-sm-4 font-weight-bold">Is Active:</div>
          <div className="col-sm-8">{contact.isactive ? 'Yes' : 'No'}</div>
        </div>*/}
      </div>
      <div className="row">
      <div className="text-center my-4">
        <Link to="/contactlist" className="btn btn-primary">
          Back to Contact List
        </Link>
      </div>
    </div>
    </div>
  );
};

export default ContactView;
